export default "__VITE_ASSET__BYaTmyKt__"